module.exports = __webpack_public_path__ + "static/media/Coupon_landingPage_2_Hooray.8a5cafcf.png";